import React from "react";

const Marker = ({ text }) => {
  return (
    <div className="marker_container">
      <div className="marker_content">
        <img
          src="/images/station.svg"
          height={15}
          width={15}
          className="marker_icon"
        />
        <div className="marker_txt">{text}</div>
      </div>
        <img src="/images/polygon1.svg" className="marker_p" height={15} width={15} />
    </div>
  );
};

export default Marker;
